// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"45626842","977":"1b467cd3"}[chunkId] + ".chunk.js";
};